import Translation from 'dcode/classes/Translation'
import ApiSite from '@/classes/ApiSite'

export default function setTitle (title = undefined) {
  const element = document.querySelector('title')

  if (element) {
    element.innerHTML = title ? `${title} — Coral.Help` : 'coral.help!'
  }

  if (ApiSite.getLanguage() === 'ru') {
    const metaEl = document.querySelector('meta[name="description"]')
    if (metaEl) {
      const metaTitle = title || 'coral.help!'
      metaEl.content = `${metaTitle} — ${Translation.get('description')}`
    }
  }
}
